import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "270",
  "slug": "spot-japan-from-satellite-imagery",
  "title": "How to Recognise Japan in Satellite Images",
  "excerpt": "Japan has mountainous islands with much of the dense urban development on coastal plains and in valleys.",
  "date": "2026-04-29",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/japan.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Japan has mountainous islands with much of the dense urban development on coastal plains and in valleys. Honshu curves through the centre of the archipelago, with Hokkaido to the north and Kyushu to the southwest. Large bays can provide a more recognisable outline than a patch of buildings."
    },
    {
      "type": "heading",
      "text": "Mountain interiors and coastal settlement"
    },
    {
      "type": "paragraph",
      "text": "Compare the broad Kanto Plain around Tokyo Bay with a narrow coastal valley. Notice how the available flat ground changes the settlement footprint."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Rice fields and compact towns also occur in South Korea and Taiwan. Building colour is weak evidence, especially across different image dates. Use the shape of a bay and the mountains behind it to check a candidate location."
    }
  ],
  "imageAlt": "Japan regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
